/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ArtifactShareCandidatesResponse {
    getFixupPrototypeFunction() { return ArtifactShareCandidatesResponse.fixupPrototype; }

    static newInstance(model: Partial<ArtifactShareCandidatesResponse>): ArtifactShareCandidatesResponse {
        let obj = Object.assign(new ArtifactShareCandidatesResponse(), model);
        ArtifactShareCandidatesResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ArtifactShareCandidatesResponse>): ArtifactShareCandidatesResponse {
        if (!model) return null;
        return ArtifactShareCandidatesResponse.newInstance(<ArtifactShareCandidatesResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ArtifactShareCandidatesResponse) {
        if (!obj) return;

        models.ArtifactShareCandidatesResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ArtifactShareCandidatesResponse): boolean {
        Object.setPrototypeOf(obj, ArtifactShareCandidatesResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.candidates) {
            for (let val of this.candidates) {
                models.ArtifactShareCandidate.fixupPrototype(val);
            }
        }
    }

    /**
     * Users in the tenant who have access to this artifact's agent
     */
    candidates: Array<models.ArtifactShareCandidate>;

}
